export const passwordRegex =
    /^(?=.*?[A-ZÆØÅ])(?=.*?[a-zæøå])(?=.*?[0-9])(?=.*[^a-zA-ZæøåÆØÅ0-9]).{8,}$/;
